export default __webpack_public_path__ + "static/media/wellgrowerKo2.e20c8be5.svg";